import { render } from "./loadingOrder.vue?vue&type=template&id=42b1924a"
import script from "./loadingOrder.vue?vue&type=script&lang=js"
export * from "./loadingOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__